import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { CUISINE_TYPE_NODE_FRAGMENT } from '../fragments'

const CUISINE_TYPES_QUERY = gql`
  query cuisineTypes {
    cuisineTypes {
      results {
        ...CuisineTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${CUISINE_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default CUISINE_TYPES_QUERY
